import script from "./AllOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./AllOrder.vue?vue&type=script&setup=true&lang=js"

import "./AllOrder.vue?vue&type=style&index=0&id=79bd89a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79bd89a1"]])

export default __exports__